import { render, staticRenderFns } from "./OpinionTypeAdd.vue?vue&type=template&id=e2530322&scoped=true"
import script from "./OpinionTypeAdd.vue?vue&type=script&lang=js"
export * from "./OpinionTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2530322",
  null
  
)

export default component.exports